import { Navigate } from 'react-router-dom';

/** Legacy /sign-up URL — redirect to the self-serve clinic signup flow. */
export function SignUp() {
  return <Navigate to="/create-clinic" replace />;
}
